import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";

const initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getAllUsers = createAsyncThunk(
  "users/getAll",
  async (args, thunkApi) => {
    try {
      const { page = 1, size = 50, ...rest } = args || {};
      const params = new URLSearchParams({ page, size });

      Object.entries(rest).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.append(key, value);
        }
      });

      const { data } = await axiosInstance.get(`/users/all?${params.toString()}`);
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response?.data || { message: "error" });
    }
  }
);

const usersAllSlice = createSlice({
  name: "usersAll",
  initialState,
  extraReducers: (b) => {
    b.addCase(getAllUsers.pending, (s) => {
      s.isLoading = true;
      s.error = null;
    })
      .addCase(getAllUsers.fulfilled, (s, { payload }) => {
        s.isLoading = false;
        s.data = payload.data?.data || [];
        s.itemsCount = Number(payload.data?.itemsCount) || 0;
        s.pages = Number(payload.data?.pages) || 0;
      })
      .addCase(getAllUsers.rejected, (s, { payload }) => {
        s.isLoading = false;
        s.error = payload?.message;
      });
  },
});

export default usersAllSlice.reducer;
